import { render, staticRenderFns } from "./PassDialog.vue?vue&type=template&id=379120d2&scoped=true"
import script from "./PassDialog.vue?vue&type=script&lang=js"
export * from "./PassDialog.vue?vue&type=script&lang=js"
import style0 from "./PassDialog.vue?vue&type=style&index=0&id=379120d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379120d2",
  null
  
)

export default component.exports